// // src/contexts/TrendsContext.js
// import React, { createContext, useContext, useState, useCallback } from 'react';

// /**
//  * @typedef {Object} Filters
//  * @property {string|null} categoryId
//  * @property {string[]|null} mainFilterGroupIds
//  * @property {string[]|null} comparisonFilterGroupIds
//  * @property {boolean} isInitialMount
//  */

// /**
//  * @typedef {Object} TrendsContextType
//  * @property {Filters} filters
//  * @property {Object|null} analysisCache
//  * @property {Object} trendsDataCache
//  * @property {Function} updateFilters
//  * @property {Function} updateAnalysisCache
//  * @property {Function} updateTrendsCache
//  */

// const INITIAL_FILTERS = {
//   categoryId: null,
//   mainFilterGroupIds: null,
//   comparisonFilterGroupIds: null,
//   isInitialMount: true
// };

// const TrendsContext = createContext(/** @type {TrendsContextType|null} */ (null));

// /**
//  * Custom hook for handling trends context with error checking
//  * @returns {TrendsContextType}
//  */
// export const useTrendsContext = () => {
//   const context = useContext(TrendsContext);
//   if (!context) {
//     throw new Error('useTrendsContext must be used within a TrendsProvider');
//   }
//   return context;
// };

// /**
//  * Provider component for trends data and filters
//  * @param {Object} props
//  * @param {React.ReactNode} props.children
//  */
// export const TrendsProvider = ({ children }) => {
//   const [filters, setFilters] = useState(INITIAL_FILTERS);
//   const [analysisCache, setAnalysisCache] = useState(null);
//   const [trendsDataCache, setTrendsDataCache] = useState({});

//   const updateFilters = useCallback((categoryId, mainIds, comparisonIds) => {
//     setFilters({
//       categoryId,
//       mainFilterGroupIds: mainIds,
//       comparisonFilterGroupIds: comparisonIds,
//       isInitialMount: false
//     });
//     // Reset caches when filters change
//     setAnalysisCache(null);
//     setTrendsDataCache({});
//   }, []);

//   const updateAnalysisCache = useCallback((data) => {
//     setAnalysisCache(prev => ({
//       ...prev,
//       ...data
//     }));
//   }, []);

//   const updateTrendsCache = useCallback((tabKey, data) => {
//     setTrendsDataCache(prev => ({
//       ...prev,
//       [tabKey]: {
//         ...prev[tabKey],
//         ...data
//       }
//     }));
//   }, []);

//   const contextValue = {
//     filters,
//     analysisCache,
//     trendsDataCache,
//     updateFilters,
//     updateAnalysisCache,
//     updateTrendsCache
//   };

//   return (
//     <TrendsContext.Provider value={contextValue}>
//       {children}
//     </TrendsContext.Provider>
//   );
// };

// // Optional: Debug component to monitor context changes
// export const TrendsDebugger = () => {
//   const { filters, analysisCache, trendsDataCache } = useTrendsContext();

//   if (process.env.NODE_ENV === 'development') {
//     console.log('Trends Context State:', {
//       filters,
//       analysisCache,
//       trendsDataCache
//     });
//   }

//   return null;
// };

// // import React, { createContext, useContext, useState, useCallback } from 'react';

// // const TrendsContext = createContext();

// // export const TrendsProvider = ({ children }) => {
// //   const [filters, setFilters] = useState({
// //     categoryId: null,
// //     mainFilterGroupIds: null,
// //     comparisonFilterGroupIds: null,
// //     isInitialMount: true
// //   });
// //   const [analysisCache, setAnalysisCache] = useState(null);
// //   const [trendsDataCache, setTrendsDataCache] = useState({});

// //   const updateFilters = useCallback((categoryId, mainIds, comparisonIds) => {
// //     setFilters({
// //       categoryId,
// //       mainFilterGroupIds: mainIds,
// //       comparisonFilterGroupIds: comparisonIds,
// //       isInitialMount: false
// //     });
// //     // 필터가 변경되면 캐시 초기화
// //     setAnalysisCache(null);
// //     setTrendsDataCache({});
// //   }, []);

// //   const updateAnalysisCache = useCallback((data) => {
// //     setAnalysisCache(data);
// //   }, []);

// //   const updateTrendsCache = useCallback((tabKey, data) => {
// //     setTrendsDataCache(prev => ({
// //       ...prev,
// //       [tabKey]: data
// //     }));
// //   }, []);

// //   return (
// //     <TrendsContext.Provider value={{
// //       filters,
// //       updateFilters,
// //       analysisCache,
// //       trendsDataCache,
// //       updateAnalysisCache,
// //       updateTrendsCache
// //     }}>
// //       {children}
// //     </TrendsContext.Provider>
// //   );
// // };

// // export const useTrendsContext = () => useContext(TrendsContext);




// // import React, { createContext, useContext, useState, useCallback } from 'react';

// // const TrendsContext = createContext();

// // export const TrendsProvider = ({ children }) => {
// //   const [analysisCache, setAnalysisCache] = useState(null);
// //   const [trendsDataCache, setTrendsDataCache] = useState({});

// //   const updateAnalysisCache = useCallback((data) => {
// //     setAnalysisCache(data);
// //   }, []);

// //   const updateTrendsCache = useCallback((tabKey, data) => {
// //     setTrendsDataCache(prev => ({
// //       ...prev,
// //       [tabKey]: data
// //     }));
// //   }, []);

// //   return (
// //     <TrendsContext.Provider value={{
// //       analysisCache,
// //       trendsDataCache,
// //       updateAnalysisCache,
// //       updateTrendsCache
// //     }}>
// //       {children}
// //     </TrendsContext.Provider>
// //   );
// // };

// // export const useTrendsContext = () => useContext(TrendsContext);

// src/contexts/TrendsContext.js
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useLanguage } from './LanguageContext.js';

/**
 * @typedef {Object} Filters
 * @property {string|null} categoryId
 * @property {string[]|null} mainFilterGroupIds
 * @property {string[]|null} comparisonFilterGroupIds
 * @property {boolean} isInitialMount
 */

/**
 * @typedef {Object} TrendsContextType
 * @property {Filters} filters
 * @property {Object|null} analysisCache
 * @property {Object} trendsDataCache
 * @property {Function} updateFilters
 * @property {Function} updateAnalysisCache
 * @property {Function} updateTrendsCache
 * @property {Function} clearLanguageCache
 */

const INITIAL_FILTERS = {
  categoryId: null,
  mainFilterGroupIds: null,
  comparisonFilterGroupIds: null,
  isInitialMount: true
};

const TrendsContext = createContext(/** @type {TrendsContextType|null} */ (null));

/**
 * Custom hook for handling trends context with error checking
 * @returns {TrendsContextType}
 */
export const useTrendsContext = () => {
  const context = useContext(TrendsContext);
  if (!context) {
    throw new Error('useTrendsContext must be used within a TrendsProvider');
  }
  return context;
};

/**
 * Provider component for trends data and filters
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export const TrendsProvider = ({ children }) => {
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [analysisCache, setAnalysisCache] = useState(null);
  const [trendsDataCache, setTrendsDataCache] = useState({});
  const { language } = useLanguage();
  const [currentLanguage, setCurrentLanguage] = useState(language);

  // Effect to handle language changes and clear relevant cache
  useEffect(() => {
    if (currentLanguage !== language) {
      // Clear cache entries for the previous language when language changes
      setTrendsDataCache(prevCache => {
        const newCache = { ...prevCache };
        // Remove cache entries that contain the old language
        Object.keys(newCache).forEach(key => {
          if (key.includes(`_${currentLanguage}`)) {
            delete newCache[key];
          }
        });
        return newCache;
      });
      setCurrentLanguage(language);
    }
  }, [language, currentLanguage]);

  const updateFilters = useCallback((categoryId, mainIds, comparisonIds) => {
    setFilters({
      categoryId,
      mainFilterGroupIds: mainIds,
      comparisonFilterGroupIds: comparisonIds,
      isInitialMount: false
    });
    // Reset caches when filters change
    setAnalysisCache(null);
    setTrendsDataCache({});
  }, []);

  const updateAnalysisCache = useCallback((data) => {
    setAnalysisCache(prev => ({
      ...prev,
      ...data
    }));
  }, []);

  const updateTrendsCache = useCallback((cacheKey, data) => {
    setTrendsDataCache(prev => ({
      ...prev,
      [cacheKey]: {
        ...prev[cacheKey],
        ...data
      }
    }));
  }, []);

  // Function to clear cache for a specific language
  const clearLanguageCache = useCallback((targetLanguage) => {
    setTrendsDataCache(prevCache => {
      const newCache = { ...prevCache };
      Object.keys(newCache).forEach(key => {
        if (key.includes(`_${targetLanguage}`)) {
          delete newCache[key];
        }
      });
      return newCache;
    });
  }, []);

  const contextValue = {
    filters,
    analysisCache,
    trendsDataCache,
    updateFilters,
    updateAnalysisCache,
    updateTrendsCache,
    clearLanguageCache
  };

  return (
    <TrendsContext.Provider value={contextValue}>
      {children}
    </TrendsContext.Provider>
  );
};

// Optional: Debug component to monitor context changes
export const TrendsDebugger = () => {
  const { filters, analysisCache, trendsDataCache } = useTrendsContext();

  if (process.env.NODE_ENV === 'development') {
    console.log('Trends Context State:', {
      filters,
      analysisCache,
      trendsDataCache: Object.keys(trendsDataCache) // Show cache keys instead of full data
    });
  }

  return null;
};